import { createSlice } from '@reduxjs/toolkit';

import { TUser } from 'shared/types/user';

const initialState = {
  isAuthenticated: false,
  anonymousUserId: null,
} as TUser;

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  selectors: {
    selectUser: state => state,
    selectIsAuthenticated: state => state.isAuthenticated,
  },
});

export const {
  reducer: userReducer,
  actions: {},
  selectors: { selectUser, selectIsAuthenticated },
} = userSlice;
